import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "id", "isReadOnly", "modules", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { Styled } from './TextEditor.styles';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultModules = {
  toolbar: [['bold', 'italic'], [{
    list: 'ordered'
  }, {
    list: 'bullet'
  }], ['link'], ['clean']]
};
var isBrowser = typeof window !== 'undefined';
var TextEditor = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      id = _ref.id,
      _ref$isReadOnly = _ref.isReadOnly,
      readOnly = _ref$isReadOnly === void 0 ? false : _ref$isReadOnly,
      _ref$modules = _ref.modules,
      modules = _ref$modules === void 0 ? defaultModules : _ref$modules,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-text-editor"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return isBrowser && _jsx(Styled.TextEditor, _objectSpread({
    ref: ref,
    id: id,
    theme: "snow",
    className: className,
    modules: modules,
    readOnly: readOnly
  }, rest));
});
TextEditor.displayName = 'Text Editor';
export default TextEditor;